import { useQuery } from "@tanstack/react-query";
import api from "@/services/api";
import type { CategoryResponse } from "@byk/shared";

interface CategoryWithCount extends CategoryResponse {
  _count?: {
    products: number;
  };
}

export function useCategories() {
  return useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      const response = await api.get<{ items: CategoryWithCount[]; total: number }>(
        "/api/categories"
      );
      return response.data.items;
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
}

export function useCategory(slug: string) {
  return useQuery({
    queryKey: ["categories", slug],
    queryFn: async () => {
      const response = await api.get<{ data: CategoryWithCount }>(
        `/api/categories/${slug}`
      );
      return response.data.data;
    },
    enabled: !!slug,
    staleTime: 1000 * 60 * 10,
  });
}

export default useCategories;
